var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "11 7 7.392 15.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.696 17h3v5.563c0 .553.166.584.37.072l3.259-8.707c.205-.512-.076-.928-.63-.928h-3V7.438c0-.554-.165-.585-.37-.073l-3.258 8.706c-.205.514.076.93.629.93"
})));
export default SvgBolt;